'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactRouter = require('react-router');

var _selectors = require('./selectors');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
   {
     "type": "keep_in_mind"
   }

   This is for displaying the keep in mind text for a job.
*/

function ViewThisJob(_ref) {
  var subsector = _ref.subsector;

  if (subsector) {
    return _react2.default.createElement(
      'p',
      { className: 'view-job' },
      _react2.default.createElement(
        'strong',
        null,
        'View this job in:'
      ),
      ' \xA0',
      _react2.default.createElement(
        _reactRouter.Link,
        { to: '/subsector/' + subsector.slug },
        subsector.label
      )
    );
  }

  return _react2.default.createElement('p', { className: 'view-job' });
}

exports.default = (0, _reactRedux.connect)(_selectors.mapStateToProps)(ViewThisJob);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/shared/modules/ViewThisJob/ViewThisJob.jsx
// module id = 1278
// module chunks = 0